import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User } from '../types/models';

interface AuthState {
  user: User | null;
  token: string | null;
  login: (user: User, token: string, refreshToken: string) => void;
  logout: () => void;
  setUser: (user: User) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      login: (user, token, refreshToken) => {
        localStorage.setItem('hash_token', token);
        localStorage.setItem('hash_refresh_token', refreshToken);
        set({ user, token });
      },
      logout: () => {
        localStorage.removeItem('hash_token');
        localStorage.removeItem('hash_refresh_token');
        set({ user: null, token: null });
      },
      setUser: (user) => set({ user }),
    }),
    {
      name: 'hash_auth',
      partialize: (state) => ({ token: state.token, user: state.user }),
    },
  ),
);
